import { usePaypalContext } from '@context/PaypalProvider';
import React from 'react';

interface IPaypalButtonContainerProps {
  children: React.ReactNode;
  hideButton: boolean;
}

const PaypalButtonContainer: React.FC<IPaypalButtonContainerProps> = ({
  children,
  hideButton,
}) => {
  const { isReady } = usePaypalContext();

  return (
    <>
      <div
        className="paypal-container"
        data-testid="PaypalButtonContainer-Button-pay-with-paypal"
      >
        {hideButton || !isReady ? (
          <div className="loader">
            <div className="animation">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        ) : null}

        <div className={hideButton ? 'hidden' : ''}>{children}</div>
      </div>
      <style jsx>{`
        .hidden {
          opacity: 0;
        }

        .paypal-container {
          position: relative;
          height: 45px;
          width: 100%;
        }

        .loader {
          display: flex;
          justify-content: center;
          position: absolute;
          width: 100%;
          height: 45px;
          background: #ffc439; /* paypal yellow */
          border-radius: 1000px;
        }

        .loader .animation {
          position: relative;
          height: 45px;
          width: 45px;
        }

        .loader .animation > div {
          position: absolute;
          top: 42%;
          width: 17%;
          height: 17%;
          border-radius: 50%;
          background: var(--black);
          animation-timing-function: cubic-bezier(0, 1, 1, 0);
        }

        .loader .animation > div:nth-child(1),
        .loader .animation > div:nth-child(2) {
          left: 9.37%;
          animation: ellipsis1 0.6s infinite;
        }

        .loader .animation > div:nth-child(3) {
          left: 40.06%;
          animation: ellipsis2 0.6s infinite;
        }

        .loader .animation > div:nth-child(4) {
          left: 70.03%;
          animation: ellipsis3 0.6s infinite;
        }

        @keyframes ellipsis1 {
          0% {
            transform: scale(0);
          }
          100% {
            transform: scale(1);
          }
        }

        @keyframes ellipsis2 {
          0% {
            transform: translate(0, 0);
          }
          100% {
            transform: translate(24px, 0);
          }
        }

        @keyframes ellipsis3 {
          0% {
            transform: scale(1);
          }
          100% {
            transform: scale(0);
          }
        }

        @media (max-width: 440px) {
          .paypal-container,
          .loader {
            height: 35px;
          }

          .loader .animation {
            height: 35px;
            width: 35px;
          }
        }
      `}</style>
    </>
  );
};

export default PaypalButtonContainer;
